"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderFulfillment = void 0;
const react_1 = __importDefault(require("react"));
const canvas_box_1 = require("../canvas-box");
const themed_text_1 = require("../themed-text");
const OrderFulfillment = (props) => {
    const { aboutCopy, title, fulfillmentMessage } = props;
    return (react_1.default.createElement(canvas_box_1.CanvasContainer, { direction: "column", justify: "space-evenly", width: "auto", "data-cy": 'order-fulfillment' },
        react_1.default.createElement(themed_text_1.ThemedSpan, { bold: true, font: "base" },
            aboutCopy,
            " ",
            title),
        react_1.default.createElement("br", null),
        react_1.default.createElement(themed_text_1.ThemedSpan, { font: "base" }, fulfillmentMessage)));
};
exports.OrderFulfillment = OrderFulfillment;
__exportStar(require("./types"), exports);
